var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "col-12 col-md-7 mb-3 mb-md-0" },
      [
        _c(
          "validation-observer",
          { ref: "contractDocumentReplacementObserver" },
          [
            _c("validation-provider", {
              attrs: { name: "Archivo", rules: "required" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function({ errors }) {
                    return [
                      _c("custom-input", {
                        attrs: {
                          "custom-error-msg":
                            "Este campo es requerido para continuar con el proceso.",
                          error: errors[0],
                          label: "Razón:",
                          maxlength: "3000",
                          type: "text"
                        },
                        model: {
                          value: _vm.razonByReplaceDocument,
                          callback: function($$v) {
                            _vm.razonByReplaceDocument = $$v
                          },
                          expression: "razonByReplaceDocument"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "col-12 col-md-5 d-flex justify-content-end align-items-end"
      },
      [
        _c(
          "action-button",
          {
            attrs: {
              id: "modal-btn-cancelar",
              i: "fas fa-times-circle",
              variant: "outline-danger mr-2"
            },
            on: { click: _vm.handleCancel }
          },
          [_vm._v(" Cancelar ")]
        ),
        _c(
          "action-button",
          {
            attrs: { i: "fa fa-save", variant: "success px-3" },
            on: { click: _vm.handleConfirm }
          },
          [_vm._v(" Guardar ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-arrow-from-right text-orange mr-1" }),
      _c("span", { staticClass: "color-gray-7 font-weight-bold font-16" }, [
        _vm._v(" Razón para Solicitud de Reemplazo ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }